import React, { useState } from 'react';
import { Card } from '../../components';
import { ConsultantsUIProvider } from './context/ConsultantsUIContext';
import ClientDropHeader from '../clients/makeandchecker/ClientDropHeader';
import ClientsDropMenu from '../clients/makeandchecker/ClientsDropMenu';
import ConsultantsTable from './table/ConsultantsTable';

export default function Consultants () {
    // eslint-disable-next-line no-unused-vars
    const [total, setTotal] = useState({ clientsDropBadges: 0 });

    // Main Component

    return (
        <ConsultantsUIProvider>
            <div className='functionalitiesPage'>
                <ClientDropHeader />
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <ClientsDropMenu clientsDropBadges={total.clientsDropBadges}/>
                    </div>
                    <div className='menuFlexRight'>
                        <Card>
                            <ConsultantsTable />
                        </Card>
                    </div>
                </div>
            </div>
        </ConsultantsUIProvider>
    );
}
